import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../main/context/Provider';
import { Project } from '../../../domain/projects/project';
import { useParams } from 'react-router-dom';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { ProjectsRepository } from '../../../infrastructure/repositories/projects/projectRepository';
import { Private_Routes } from '../../../main/constants';
import { ProjectForm } from '../components/form/ProjectForm';

export const UpdateProjectPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const [project, setProject] = useState<Project>();
    const { id } = useParams<{ id: string }>();

    const { webPage } = changeWebPageTitleService(
        isSkinSmart,
        'Actualizar Empleado'
    );

    useEffect(() => {
        if (id) {
            ProjectsRepository.GetProject(id).then((response) => {
                setProject(response);
                console.log(response);
            });
        }
    }, [id]);

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Proyectos',
                route: Private_Routes.PROJECT_PAGE,
            },
            {
                label: webPage,
                route: Private_Routes.UPDATE_PROJECT,
            },
        ]);
    }, [lang]);

    return (
        <>
            {project != null && (
                <ProjectForm isNewProject={false} project={project} />
            )}
        </>
    );
};
